"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginRedirect = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var LoginRedirect = function () { return react_1.default.createElement(react_router_dom_1.Redirect, { to: "/login" }); };
exports.LoginRedirect = LoginRedirect;
//# sourceMappingURL=index.js.map